export default __webpack_public_path__ + "static/stefan_seated-cc4e10d64c7a5f3f290e957b064b5f1a.jpg";